import angular from 'angular';

let AuthFactory = angular.module('AuthFactory', [])
.factory('AuthFactory', ($rootScope, HttpFactory, URLS) => {
	'ngInject';
	const USER_TYPES = {
		USER: "user",
		TEAM: "team",
	};
	return {
		USER_TYPES : USER_TYPES,
		login: (data, userType) => {
			let url = HttpFactory.buildUrl(URLS.LOGIN, {
				userType: userType
			});

			return HttpFactory.post(url, data);
		},
		recoverPassword: (userType, email) => {
			let url = HttpFactory.buildUrl(URLS.RECOVER_PASSWORD, {
				userType: userType
			});
			let body = {
				email: email,
			};
			return HttpFactory.post(url, body);
		},
		resetPassword: (userType, code, password, password_confirmation) => {
			let url = HttpFactory.buildUrl(URLS.RESET_PASSWORD, {
				userType: userType
			});
			let body = {
				code: code,
				password: password,
				password_confirmation: password_confirmation,
			};
			return HttpFactory.post(url, body);
		},
		changePassword: (userType, data) => {
			let url = HttpFactory.buildUrl(URLS.CHANGE_PASSWORD, {
				userType: userType
			});

			return HttpFactory.post(url, data);
		},
	};
}).name;

export default AuthFactory;



// WEBPACK FOOTER //
// ./client/app/services/auth.factory.js